import { initDataLayer, isBrowser } from '../util';
export function pushFilterRemoval(group, label) {
    initDataLayer();
    if (!isBrowser)
        return;
    window.dataLayer.push({
        event: 'filterRemoved',
        filterRemovedGroup: group,
        filterRemovedValue: label,
    });
}
